import axios from 'axios';

const llmProxyUrl = (process.env.REACT_APP_LLM_PROXY_URL || '').replace(/\/$/, '');

const getAuthHeaders = () => {
  const token = window.localStorage.getItem('access');
  return token ? { Authorization: `JWT ${token}` } : {};
};

export const extractOrderEntities = async (text) => {
  if (!llmProxyUrl) {
    throw new Error('REACT_APP_LLM_PROXY_URL is not defined in the environment variables.');
  }

  try {
    const { data } = await axios.post(
      `${llmProxyUrl}/api/llm/order-autofill`,
      { text },
      { headers: getAuthHeaders() },
    );
    return data;
  } catch (error) {
    console.error('Error extracting order autofill content:', error);
    throw error;
  }
};
